import { createGlobalStyle } from 'styled-components';
import FontSvg from './RuiIcon/rui-icon-webfont.svg';
import FontWoff from './RuiIcon/rui-icon-webfont.woff';
import FontWoff2 from './RuiIcon/rui-icon-webfont.woff2';

// eslint-disable-next-line @typescript-eslint/no-unused-expressions
createGlobalStyle`
  @font-face {
    font-family: 'rui-icon';
    font-display: swap;
    src:
      url("${FontWoff2}") format("woff2"),
      url("${FontWoff}") format("woff"),
      url("${FontSvg}#rui-icon") format("svg");
    font-weight: normal;
    font-style: normal;
  }
`;

const iconContent = {
  360: '\\e900',
  'save-hollow': '\\e000',
  'user-on': '\\e001',
  'user-off': '\\e002',
  office: '\\e003',
  image: '\\e004',
  tags: '\\e005',
  iphone: '\\e006',
  ipad: '\\e007',
  warning: '\\e008',
  cog: '\\e009',
  link: '\\e00a',
  navdeck: '\\e00b',
  'video-camera': '\\e00c',
  linkedin: '\\e00d',
  camera: '\\e00e',
  rss: '\\e00f',
  comments: '\\e010',
  play: '\\e011',
  home: '\\e012',
  github: '\\e013',
  'multi-user': '\\e014',
  quotes: '\\e016',
  back: '\\e017',
  forward: '\\e018',
  googleplus: '\\e019',
  avatar: '\\e01a',
  listview: '\\e01b',
  'arrow-solid-up': '\\e01c',
  'arrow-solid-left': '\\e01d',
  'arrow-up': '\\e01e',
  'arrow-left': '\\e01f',
  email: '\\e020',
  bed: '\\e021',
  bath: '\\e022',
  car: '\\e023',
  save: '\\e024',
  mappin: '\\e025',
  search: '\\e026',
  'arrow-solid-right': '\\e027',
  'arrow-solid-down': '\\e028',
  add: '\\e029',
  'arrow-down': '\\e02a',
  'arrow-right': '\\e02b',
  call: '\\e02c',
  floorplan: '\\e02d',
  facebook: '\\e02e',
  twitter: '\\e02f',
  pinterest: '\\e030',
  share: '\\e031',
  calculator: '\\e032',
  dollar: '\\e033',
  wordpress: '\\e034',
  calendar: '\\e035',
  tick: '\\e039',
  lock: '\\e044',
  youtube: '\\e046',
  cross: '\\e600',
  'bed-small': '\\e601',
  'bath-small': '\\e602',
  'car-small': '\\e603',
  'save-hollow-small': '\\e604',
  'save-small': '\\e605',
  '3d-tour': '\\e606',
  projects: '\\e608',
  'multi-user2': '\\e609',
  download: '\\e60a',
  minimise: '\\e60b',
  'multi-device': '\\e60c',
  desktop: '\\e60d',
  laptop: '\\e60e',
  watch: '\\e60f',
  unlock: '\\e610',
  confirm: '\\e611',
  delete: '\\e612',
  commission: '\\e613',
  document: '\\e614',
  reservation: '\\e615',
  contact: '\\e616',
  edit: '\\e617',
  reports: '\\e618',
  instagram: '\\e619',
  'search-small': '\\e901',
  'multi-user-small': '\\e902',
  'camera-inverted': '\\e903',
  'check-on': '\\e904',
  'check-off': '\\e905',
  'arrow-down-small': '\\e906',
  'arrow-left-small': '\\e907',
  'arrow-right-small': '\\e908',
  'arrow-up-small': '\\e909',
  'back-small': '\\e90a',
  'forward-small': '\\e90b',
  video: '\\e90c',
  'camera-small-inverted': '\\e90d',
  'camera-small': '\\e90e',
  'floorplan-inverted': '\\e90f',
  'question-small': '\\e910',
  'floorplan-small': '\\e911',
  'play-inverted': '\\e912',
  'play-small-inverted': '\\e913',
  'play-small': '\\e914',
  '3d-tour-inverted': '\\e915',
  '3d-tour-small-inverted': '\\e916',
  '3d-tour-small': '\\e917',
  remove: '\\e918',
  'listview-small': '\\e919',
  filters: '\\e91a',
  'filters-small': '\\e91b',
  'edit-small': '\\e91c',
  bell: '\\e91d',
  'bell-small': '\\e91e',
  'call-small': '\\e91f',
  print: '\\e920',
  'print-small': '\\e921',
  'email-small': '\\e922',
  'save-search-small': '\\e923',
  'save-search': '\\e924',
  'home-small': '\\e925',
  'cog-small': '\\e926',
  'user-on-small': '\\e927',
  'avatar-small': '\\e928',
  'user-off-small': '\\e929',
  question: '\\e92a',
  'arrow-next': '\\e92b',
  'arrow-previous': '\\e92c',
  'star-half': '\\e92d',
  'star-half-small': '\\e92e',
  'play-video': '\\e92f',
  'floorplan-small-inverted': '\\e930',
  expand: '\\e931',
  'expand-small': '\\e932',
  'minimise-small': '\\e933',
};

export default iconContent;
